import { TFunction } from 'i18next';

import { DEFAULT_NUMBER_OF_DAYS } from '@/utils/constants/common';
import { PERIOD } from '@/utils/enums/common';
import { PERIOD_USAGE_DESCRIPTION } from '@/utils/enums/newRequest';

export const displayNumberOfDays = (count = DEFAULT_NUMBER_OF_DAYS, t: TFunction) =>
    t('newRequest_summary_day', { count: Math.max(count, DEFAULT_NUMBER_OF_DAYS) });

export const periodText = (periodType = PERIOD.YEAR, t: TFunction) =>
    t(PERIOD_USAGE_DESCRIPTION[periodType]).toLowerCase();
